// extracted by mini-css-extract-plugin
export default {"mainContainer":"CreateNewOrder_mainContainer__VJJFK","createNewOrderCard":"CreateNewOrder_createNewOrderCard__Wk2B7","createBtn":"CreateNewOrder_createBtn__rogPP"};